import { render, staticRenderFns } from "./LaitelaTab.vue?vue&type=template&id=f7c6e270"
import script from "./LaitelaTab.vue?vue&type=script&lang=js"
export * from "./LaitelaTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports